<template>
    <div class="reset-filters">
        <transition name="fade">
            <span
                v-if="show"
                :key="1"
                class="mb-1 mr-2 d-block reset-filters--inner"
                :min-width="145"
                @click="resetFilters"
                >Wis filters</span
            >
        </transition>
    </div>
</template>
<script>
import { EventBus } from '../../components/helpers/eventbus';
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        resetFilters() {
            EventBus.$emit('reset-filters');
        }
    }
};
</script>
<style lang="scss" scoped>
.reset-filters {
    height: 20px;
}

.reset-filters--inner {
    font-size: small;
    text-align: right;
    cursor: pointer;
    color: #7fd060;
    @include media-breakpoint-up(lg) {
        color: #ffffff;
        border: 0;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
